import { keyframes } from 'styled-components';

export const keyframeOpacity = (start: number, end: number) =>
  keyframes`
    from {
      opacity: ${start}
    }
    to {
      opacity: ${end}
    }
  `;

export const keyframeScale = (start: number, end: number) =>
  keyframes`
    0% {
      transform: scale(${start})
    }
    100% {
      transform: scale(${end})
    }
  `;

export const keyFrameTranslateY = (start: number, end: number) =>
  keyframes`
    0% {
      transform: translateY(${start}%)
    }
    100% {
      transform: translateY(${end}%)
    }
  `;

export const keyframeRotate = (start: number, end: number) =>
  keyframes`
    0% {
      transform: rotate(${start}deg)
    }
    100% {
      transform: rotate(${end}deg)
    }
  `;
